"use strict";
import { useRef, useLayoutEffect, useEffect } from "react";
const useIsomorphicLayoutEffect = typeof document !== "undefined" ? useLayoutEffect : useEffect;
function useLatest(value) {
  const ref = useRef(value);
  useIsomorphicLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
}
export {
  useLatest
};
